module.exports = __webpack_public_path__ + "img/bg (3).d90accb6.jpg";